<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2023-02-22 15:17:15
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-04-21 17:33:45
 * @FilePath: \pigbox\src\views\Home\Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myBodyBox">
    <el-container>
      <el-header class="myheader">
        <div class="headerLeft">泗小碗商城后台管理系统</div>
        <div class="headerRight">
          <el-button size="mini">退出登录</el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" class="myAside">
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <router-link to="/shop">
              <el-menu-item index="1">
                <i class="el-icon-s-shop"></i>
                <span slot="title">商家审核</span>
              </el-menu-item>
            </router-link>
            <router-link to="/goods">
              <el-menu-item index="2">
                <i class="el-icon-setting"></i>
                <span slot="title">商品模板</span>
              </el-menu-item>
            </router-link>
            <router-link to="/withdrawal">
              <el-menu-item index="3">
                <i class="el-icon-s-check"></i>
                <span slot="title">提现审核</span>
              </el-menu-item>
            </router-link>
            <router-link to="/popularize">
              <el-menu-item index="4">
                <i class="el-icon-camera-solid"></i>
                <span slot="title">推广审核</span>
              </el-menu-item>
            </router-link>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
.myheader {
  width: 100vw;
  height: 50px;
  background-color: #545c64;
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
}
.myAside {
  width: 200px;
  height: 100vh;
  background-color: #545c64;
}
.myBodyBox {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.headerLeft {
  width: 200px;
  height: 50px;
  /* background-color: aqua; */
  color: white;
  text-align: center;
  line-height: 50px;
  /* font-size: 8px; */
  font-size: 15px;
}
.headerRight {
  width: 200px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>